import React from "react";
import { Stack, Typography } from "@mui/material";

const sx = {
  fontSize: 12,
  fontWeight: 500,
};

const WorkOrderResultItem = ({ label, part, lotNumber }) => {
  return (
    <Stack direction="row" gap="5px" alignItems="center">
      <Typography sx={{ fontSize: 12 }}>{label}</Typography>
      <Typography sx={{ fontSize: 12 }}>-</Typography>
      <Typography sx={{ ...sx, color: "hubColors.mainFocus" }}>
        {part}
      </Typography>
      <Typography sx={{ fontSize: 12 }}>-</Typography>
      <Typography sx={sx}>{lotNumber}</Typography>
    </Stack>
  );
};

export default WorkOrderResultItem;
